import { RouteInfo } from './sidebar.metadata';
export function purchaseFinancing() {
    const PMROUTES: RouteInfo[] = []
    if (sessionStorage.getItem('purchaseFinancing') == 'true') {
        PMROUTES.push(
            {
                path: '', title: 'Purchase Financing', icon: 'ft-aperture', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
                submenu: [
                    {
                        path: '/Vendor/pharmacy/Dashboard', title: 'Dashboard', icon: 'fa fa-tachometer', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    {
                        path: '/Vendor/pharmacy/upload-invoice', title: 'Upload Invoices', icon: 'ft-aperture', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },
                    {
                        path: '/Vendor/pharmacy/invoices', title: 'Invoices', icon: 'ft-aperture', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                    },


                ]
            },
        )
    }

    return PMROUTES
}